import { Box, CircularProgress, Typography, Grid } from '@mui/material/';
import { FC } from 'react';
import { IoMdFolderOpen, IoMdAlarm, IoMdCheckmarkCircleOutline, IoIosAlert } from 'react-icons/io';
import { CardType } from './styles';

interface CardProps {
  value: number | undefined;
  loading: boolean;
}

export const InProgressCard: FC<CardProps> = ({ value, loading }) => {
  const validValue = value !== undefined ? value : '-';
  return (
    <Grid item xs={1} sm={2} md={2} lg={3} xl={1}>
      <CardType
        sx={{
          background: 'linear-gradient(300deg, rgba(88, 129, 232, 0.91) 0%, rgba(29, 222, 218, 0.9) 100%)',
          backgroundSize: '180% 180%',
          '@keyframes gradColorTransition': {
            '0%': {
              backgroundPosition: '0% 50%',
            },
            '50%': {
              backgroundPosition: '100% 50%',
            },
            '100%': {
              backgroundPosition: '0% 50%',
            },
          },
          animation: 'gradColorTransition  11s ease infinite',
        }}
      >
        <Box>
          <Typography variant='h4'>{loading ? <CircularProgress /> : validValue}</Typography>
          <Typography variant='h6'>Processos em Progresso</Typography>
        </Box>

        <IoMdFolderOpen size={65} />
      </CardType>
    </Grid>
  );
};

export const DelayCard: FC<CardProps> = ({ value, loading }) => {
  const validValue = value !== undefined ? value : '-';
  return (
    <Grid item xs={1} sm={2} md={2} lg={3} xl={1}>
      <CardType
        sx={{
          background: 'linear-gradient(257deg, rgba(213, 0, 34, 0.91) 0%, rgba(255, 99, 99, 0.9) 100%)',
          backgroundSize: '180% 180%',
          '@keyframes gradColorTransition': {
            '0%': {
              backgroundPosition: '0% 50%',
            },
            '50%': {
              backgroundPosition: '100% 50%',
            },
            '100%': {
              backgroundPosition: '0% 50%',
            },
          },
          animation: 'gradColorTransition  11s ease infinite',
        }}
      >
        <Box>
          <Typography variant='h4'>{loading ? <CircularProgress /> : validValue}</Typography>
          <Typography variant='h6'>Processos Atrasados</Typography>
        </Box>

        <IoMdAlarm size={65} />
      </CardType>
    </Grid>
  );
};

export const ConcludedCard: FC<CardProps> = ({ value, loading }) => {
  const validValue = value !== undefined ? value : '-';
  return (
    <Grid item xs={1} sm={2} md={2} lg={3} xl={1}>
      <CardType
        sx={{
          background: 'linear-gradient(257deg, rgba(59, 182, 50, 0.91) 0%, rgba(65, 225, 151, 0.9) 100%)',
          backgroundSize: '180% 180%',
          '@keyframes gradColorTransition': {
            '0%': {
              backgroundPosition: '0% 50%',
            },
            '50%': {
              backgroundPosition: '100% 50%',
            },
            '100%': {
              backgroundPosition: '0% 50%',
            },
          },
          animation: 'gradColorTransition  11s ease infinite',
        }}
      >
        <Box>
          <Typography variant='h4'>{loading ? <CircularProgress /> : validValue}</Typography>
          <Typography variant='h6'>Processos Finalizados</Typography>
        </Box>

        <IoMdCheckmarkCircleOutline size={65} />
      </CardType>
    </Grid>
  );
};

export const ExpireCard: FC<CardProps> = ({ value, loading }) => {
  const validValue = value !== undefined ? value : '-';
  return (
    <Grid item xs={1} sm={2} md={2} lg={3} xl={1}>
      <CardType
        sx={{
          '@media(max-width:550px)': {
            maxHeight: '150px',
          },
          '@media(min-width: 900px)': {
            maxHeight: '150px',
          },
          background: 'linear-gradient(257deg, rgba(255, 138, 86, 0.91) 0%, rgba(255, 212, 66, 0.9) 100%)',
          backgroundSize: '180% 180%',
          '@keyframes gradColorTransition': {
            '0%': {
              backgroundPosition: '0% 50%',
            },
            '50%': {
              backgroundPosition: '100% 50%',
            },
            '100%': {
              backgroundPosition: '0% 50%',
            },
          },
          animation: 'gradColorTransition  11s ease infinite',
        }}
      >
        <Box>
          <Typography variant='h4'>{loading ? <CircularProgress /> : validValue}</Typography>
          <Typography variant='h6'>Convênios Perto de Vencer</Typography>
        </Box>

        <IoIosAlert size={65} />
      </CardType>
    </Grid>
  );
};
